import { Record } from 'immutable';

export interface ExportToCsvInterface {
  isBusy: boolean;
  isError: boolean;
}

export const initialState: ExportToCsvInterface = {
  isBusy: false,
  isError: false,
};

export default class ExportToCsvState extends Record(initialState) { }
